import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { registerSw, appFor } from "../../lib/push";

const MANIFEST = { buma: "/manifest.json", family: "/manifest-family.json", kids: "/manifest-kids.json", staff: "/manifest-staff.json" };
const THEME = { buma: "#0038EB", family: "#0038EB", kids: "#F26A1B", staff: "#0038EB" };

// Swaps the web-app manifest per door (family / kids / staff / main) and registers the service worker once.
export function PwaManager() {
  const { pathname } = useLocation();
  useEffect(() => { registerSw(); }, []);
  useEffect(() => {
    const app = appFor(pathname);
    let link = document.querySelector('link[rel="manifest"]');
    if (!link) { link = document.createElement("link"); link.rel = "manifest"; document.head.appendChild(link); }
    if (link.getAttribute("href") !== MANIFEST[app]) link.setAttribute("href", MANIFEST[app]);
    const theme = document.querySelector('meta[name="theme-color"]');
    if (theme) theme.setAttribute("content", THEME[app]);
  }, [pathname]);
  return null;
}
